export const REQUEST_STATUS = {
  EMPTY: 'empty',
  LOADING: 'loading',
  READY: 'ready',
  ERROR: 'error',
}

export const FETCH_TOP_OFFERS = 'FETCH_TOP_OFFERS'
export const FETCH_TOP_OFFERS_FULFILLED = 'FETCH_TOP_OFFERS_FULFILLED'
export const FETCH_TOP_OFFERS_REJECTED = 'FETCH_TOP_OFFERS_REJECTED'
export const REMOVE_TOP_OFFER = 'FETCH_WEATHER_REJECTED'

export const TYPES = {
  FETCH_TOP_OFFERS,
  FETCH_TOP_OFFERS_FULFILLED,
  FETCH_TOP_OFFERS_REJECTED,
}

export const initialState = {
  status: REQUEST_STATUS.EMPTY,
  topOffers: [],
  error: undefined,
}

function topOffersReducer(state, action) {
  switch (action.type) {
    case FETCH_TOP_OFFERS:
      return { ...state, status: REQUEST_STATUS.LOADING }
    case FETCH_TOP_OFFERS_FULFILLED:
      return {
        ...state,
        status: REQUEST_STATUS.READY,
        topOffers: action.payload,
      }
    case FETCH_TOP_OFFERS_REJECTED:
      return {
        ...state,
        status: REQUEST_STATUS.ERROR,
        topOffers: [],
        error: action.payload,
      }
    case REMOVE_TOP_OFFER:
      return {
        ...state,
        topOffers: state.topOffers.filter(offer => offer.uuid !== action.payload),
      }
    default:
      throw new Error('An action must be supplied')
  }
}

export { topOffersReducer }
